// Schema copy may contain formatting; metadata, reports, and pickers display only its wording.
export function plainFormCopy(value: string | null | undefined): string {
  if (!value || !/[<&]/.test(value)) return value ?? ""
  const template = document.createElement("template")
  template.innerHTML = value
  return template.content.textContent ?? ""
}
